

import React, { useEffect, useState } from 'react';
import { Card, Divider, Button } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import services from '../../services';
import { toast } from 'react-toastify';
import { QRCodeCanvas } from 'qrcode.react';
import { socket } from '../../socket';

const AddClient = ({ addClientStatus, setAddClientStatus, getClientWhatsapp, setAllClient }) => {
    const [clientName, setClientName] = useState('');
    const [error, setError] = useState(''); 
    
    const validateClientName = (name) => {
        if (!name) return 'Please enter a name';
        const regex = /^[a-zA-Z0-9]*$/; 
        if (!regex.test(name)) return 'Name cannot contain spaces or special characters';
        return '';
    };

    const handleClientAdd = async () => {
        try {
            const response = await services.Whatsapp.CLIENT_GENERATE({ clientId: clientName });
            const res = await services.Whatsapp.GET_ALL_CLIENT();
            getClientWhatsapp();
            toast.success('Client Add SuccessFully...');

        } catch (error) {
            toast.error(error?.response?.data?.error || 'Error adding client'); P
        }
    };
    const handleSubmit = () => {
        const validationError = validateClientName(clientName);
        if (validationError) {
            setError(validationError);
            return;
        }
        handleClientAdd();
        setAddClientStatus(false);
        setClientName('');
        setError('');
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setClientName(value);
        setError(validateClientName(value)); 
    };
    return (
        <Modal show={addClientStatus} onHide={() => setAddClientStatus(false)} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title>Add Client</Modal.Title>
            </Modal.Header>
            <Divider />
            <Modal.Body style={{ maxHeight: '500px', overflowY: 'auto', minHeight: '100px' }}>
                <label>Enter Client Name </label>
                <input
                    type="text"
                    className="h-10 w-full border-r  text-gray-900 font-i focus:outline-none p-3 border-i input-border"
                    placeholder="Enter Client Name"
                    value={clientName}
                    onChange={handleInputChange}
                    onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                />
                   {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outlined" color="default" onClick={() => setAddClientStatus(false)}>
                    Close
                </Button>
                <Button style={{ marginLeft: '10px' }} variant="contained" onClick={handleSubmit}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
const QrBlock = ({ onClose, qrStatus, clientQr, setStep }) => {
    const [qrCodeData, setQrCodeData] = useState(null);
    useEffect(() => {
        if (clientQr) {
            handleGenerateQr();
        }
    }, [clientQr]);
    const handleGenerateQr = async () => {
        try {
            const response = await services.Whatsapp.CLIENT_GENERATE_QRCODE(clientQr);
            const qrData = response?.data?.data?.[0];
            setQrCodeData(qrData?.qr);
            qrData?.whatsappConnected == 'Connected' && onClose();
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Modal show={qrStatus} onHide={() => { onClose(); setStep(1) }} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title>Qr Code</Modal.Title>
            </Modal.Header>
            <Divider />
            <Modal.Body style={{ maxHeight: '500px', overflowY: 'auto', minHeight: '100px' }}>
                {qrCodeData && (
                    <div style={{ marginTop: '20px' }}>
                        <h3>Scan this QR code to log in to WhatsApp:</h3>
                        <div
                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}
                        >
                            <QRCodeCanvas value={qrCodeData} size={256} />
                        </div>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};
const WhatsappAuth = ({ whatsAppStatus, onClose }) => {
    const [allClient, setAllClient] = useState([]);
    const [addClientStatus, setAddClientStatus] = useState(false);
    const [qrStatus, setQrStatus] = useState(false);
    const [clientQr, setClientQr] = useState('');
    const [step, setStep] = useState(1);

    useEffect(() => {
        getClientWhatsapp();
    }, []);
    const getClientWhatsapp = async () => {
        try {
            const { data } = await services.Whatsapp.GET_ALL_CLIENT();
            setAllClient(data || []);
        } catch (e) {
            console.error(e);
        }
    };

    const handleDeleteClient = async (id) => {
        try {
            const response = await services.Whatsapp.DELETE_WHATSAPP_CLIENT(id, {
                whatsappConnected: "Disconnected"
            });
            getClientWhatsapp();
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            {!addClientStatus && step === 1 && (
                <Modal show={whatsAppStatus} onHide={onClose} centered size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <div className="p-2">Synced WhatsApp Accounts List</div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: '500px', overflowY: 'auto' }}>
                        {allClient && allClient.length > 0 ? (
                            <div className="overflow-x-auto py-2">
                                <table className="min-w-full bg-white border border-solid border-gray-200 rounded-xl shadow-md overflow-hidden">
                                    <thead>
                                        <tr className="bg-gray-50 border-b-2 border-gray-200">
                                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">No.</th>
                                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Name</th>
                                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Created</th>
                                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Last Updated</th>
                                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Status</th>
                                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allClient.map((item, index) => (
                                            <tr key={item.id || item.clientId} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">{index + 1}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">{item?.clientId || '-'}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">{item?.createdAt ? new Date(item.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">{item?.updatedAt ? new Date(item.updatedAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">{item?.whatsappConnected === 'Connected' ? 'Connected' : 'Not Connected'}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900 flex gap-2 items-center">
                                                    {item?.whatsappConnected !== 'Connected' ? (
                                                        <button
                                                            className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-xs"
                                                            onClick={() => {
                                                                setQrStatus(true);
                                                                setClientQr(item?.clientId);
                                                                setStep(2)
                                                            }}
                                                        >
                                                            Scan QR
                                                        </button>
                                                    ) : (
                                                        <button
                                                            className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-xs"
                                                            onClick={() => handleDeleteClient(item?.id)}
                                                        >
                                                            Disconnect
                                                        </button>
                                                    )}

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center text-gray-500 py-8">No Client</div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>

                        <Button
                            style={{ marginLeft: '10px', textTransform: 'none' }}
                            variant="contained"
                            onClick={() => setAddClientStatus(true)}
                        >
                            Sync New WhatsApp
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            {addClientStatus && (
                <AddClient
                    addClientStatus={addClientStatus}
                    setAddClientStatus={setAddClientStatus}
                    getClientWhatsapp={getClientWhatsapp}
                    setAllClient={setAllClient}
                />
            )}

            {qrStatus && step === 2 && (
                <QrBlock
                    qrStatus={qrStatus}
                    clientQr={clientQr}
                    setStep={setStep}
                    step={step}
                    onClose={() => {
                        setQrStatus(false);
                        setClientQr('');
                        getClientWhatsapp();
                    }}
                />
            )}
        </>
    );
};

export default WhatsappAuth;
